import cs from 'classnames';
import { IInputProps } from 'types/components/inputs/input.interface';
import './CheckboxInput.scss';

const CheckboxInput = ({
  children,
  error,
  helperText = '',
  isBlocked = false,
  isError,
  label,
  showErrors = true,
  wrapperClassName = '',
  displayMode,
  ...props
}: IInputProps) => {
  const { className = '', name, touched = true, value, type } = props;

  const showErrorMessage = Boolean(touched && error);

  const inputContainerClasses = cs('checkbox', {
    displayMode,
    'has-value': !!value,
    'has-error': showErrorMessage,
    [`${type}`]: type,
    [className]: className,
  });
  return (
    <div className={inputContainerClasses}>
      <label htmlFor={name}>
        <input type='checkbox' {...props} name={name} id={name} />
        {label}
      </label>
    </div>
  );
};

export default CheckboxInput;
